import { Account } from './account';
import { Address } from './address';
import { Disease } from './disease';
import { Image } from './image';
import { ObjectImage } from './object-image';
import { Type } from './type';

export interface Environment {
  address?: Address;
  addressId?: number;
  allFundInsuranceTypes?: boolean;
  allFundSupportTypes?: boolean;
  applicationRequirements?: boolean;
  class?: string;
  createDate?: Date;
  creatorAccount?: Account;
  creatorAccountId?: number;
  dayOfWeek?: number;
  disclaimer?: string;
  diseaseKeywordFilter?: boolean;
  diseases?: Disease[];
  downloadIndividualFunds?: boolean;
  email?: string;
  id?: number;
  footerHeight?: number;
  grantAmountLabel?: string;
  guid?: string;
  hideFundGrantAmountPdf?: boolean;
  householdIncomeFilter?: boolean;
  householdPersonsFilter?: boolean;
  image?: Image;
  imageAcronym?: string;
  imageTime?: number;
  imageType?: string;
  insuranceFilter?: boolean;
  insuranceTypes?: Type[];
  legalName?: string;
  maxIncome?: boolean;
  name?: string;
  pdfLogo?: string;
  pdfLogoObjectImage?: ObjectImage;
  pdfTitle?: string;
  pediatricFunds?: boolean;
  phone?: string;
  state?: string;
  stateFilter?: boolean;
  stateLabel?: string;
  supportFilter?: boolean;
  supportTypes?: Type[];
  terms?: string;
  termsPlacement?: string;
  zipcodeFilter?: boolean;
}